import { render, staticRenderFns } from "./EmptyDashboardState.vue?vue&type=template&id=1450c56c&scoped=true"
import script from "./EmptyDashboardState.vue?vue&type=script&lang=js"
export * from "./EmptyDashboardState.vue?vue&type=script&lang=js"
import style0 from "./EmptyDashboardState.vue?vue&type=style&index=0&id=1450c56c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450c56c",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QDialog,QCard,QCardSection,QCardActions});
